import { useEffect, useMemo, useState } from 'react';
import { AuthProvider } from './context/AuthContext';
import { PermissionsProvider } from 'context/PermissionsContext';
import LoaderPreDS from './components/LoaderPreDS/LoaderPreDS.jsx';
import { useDesignSystem } from './hooks/useDesignSystem';
import AppRoutes from './routes/AppRoutes';
import { loadDesignSystemCSS } from './utils/loadCSS';
import { loadLocaleFile } from './i18n';
import { NotificationsRealtimeProvider } from 'context/notifications/NotificationsRealtimeContext';
import { LanguageProvider } from './context/LanguageContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { SnackbarProvider } from './context/SnackbarContext';
import { createTableWithI18n } from './utils/withTableI18n';

function App() {
  const DesignSystemComponents = useDesignSystem();
  const [ready, setReady] = useState(false);
  const [minTimePassed, setMinTimePassed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMinTimePassed(true), 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    loadDesignSystemCSS();

    async function init() {
      try {
        await Promise.all([loadLocaleFile('menu')]);
      } catch (err) {
        console.error('Error al cargar idioma global:', err);
      } finally {
        setReady(true);
      }
    }

    init();
  }, []);

  const enhancedComponents = useMemo(() => {
    if (!DesignSystemComponents) return null;
    return {
      ...DesignSystemComponents,
      Table: createTableWithI18n(DesignSystemComponents.Table),
    };
  }, [DesignSystemComponents]);

  const allReady = enhancedComponents && ready && minTimePassed;

  if (!allReady) return <LoaderPreDS />;

  return (
    <LanguageProvider>
      <CurrencyProvider>
      <AuthProvider>
        <PermissionsProvider>
          <NotificationsRealtimeProvider>
            <SnackbarProvider>
              <AppRoutes DesignSystemComponents={enhancedComponents} />
            </SnackbarProvider>
          </NotificationsRealtimeProvider>
        </PermissionsProvider>
      </AuthProvider>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
